import { render } from "./notify-item.vue?vue&type=template&id=718efe2a&scoped=true"
import script from "./notify-item.vue?vue&type=script&lang=js"
export * from "./notify-item.vue?vue&type=script&lang=js"

import "./notify-item.vue?vue&type=style&index=0&id=718efe2a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718efe2a"]])

export default __exports__